<template lang="pug">
  .figure#figure
    figure.imagem
      a(:href="imagem"): img(:src="imagem", class="my-album")
      figcaption: small(v-html='legenda')
</template>

<style lang="scss">

  #figure {
    .imagem {
      position: relative;
      display: block;
      width: 100%;
      height: auto;
      border-radius: 7px;
      margin-bottom: 15px;
      img {
        display: block;
        width: 100%;
        height: 100%;
        max-height: 200px;
        object-fit: cover;
        border-radius: 7px;
      }
      > figcaption {
        text-align: center;
        padding: 7px 0;
      }
    }
  }
</style>

<script>
  import $ from 'jquery/src/jquery'

  export default {
    props: {
      imagem: { type: String, required: true },
      legenda: { type: String, required: false }
    },
    mounted: function () {
      $('#figure a').simpleLightbox()
    }
  }
</script>



// WEBPACK FOOTER //
// ImagemCover.vue?4e0b9475